import { render, staticRenderFns } from "./ModalTopicSelectedFile.vue?vue&type=template&id=39f591c4&"
import script from "./ModalTopicSelectedFile.vue?vue&type=script&lang=ts&"
export * from "./ModalTopicSelectedFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports